import { getContactFormMessageSuccess, getStepsProviderError } from './slices'
import Api from 'utils/api'
import { showPopup } from 'components/Modal/slices'

export const sendContactMessage = (requestData) => async (dispatch) => {
	try {
		if (requestData) {
			Api.post('/email/contact-us', requestData)
				.then((res) => {
					dispatch(getContactFormMessageSuccess(res))
				})
				.catch((error) => {
					dispatch(showPopup(error))
				})
		}
	} catch (error) {
		dispatch(getStepsProviderError())
	}
}
